import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import TMGCourses from './section-components/tmg-college-of-arts-and-science-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const TMG = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Arts and Science College Chennai | TMG  Arts and Science College</title>
            <meta name="description" content="TMG College is a group of MIET Institutions located in Chennai, Tamil Nadu. We offer the best education in the field of Arts and Science." />
        </Helmet>
        <PageHeader headertitle="TMG College of Arts & Science"  />
        <TMGCourses />
        <Footer />
    </div>
}

export default TMG